import React from "react";
import { Box, Typography, Paper, Stack, Chip } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { getCurrentDate } from "../../../../helpers";
import { REPORT_CATEGORIES } from "../constants/reportCategories";

export const SummaryStep = ({ watchedCategory, watchedSubcategory, watchedDescription }) => {
  const currentCategory = REPORT_CATEGORIES.find(cat => cat.id === watchedCategory);
  const currentSubcategory = currentCategory?.subcategories?.find(sub => sub.id === watchedSubcategory);

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        <FormattedMessage id="general.review-information-title" defaultMessage="Überprüfen Sie Ihre Angaben" />
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        <FormattedMessage id="general.review-information-description" defaultMessage="Bitte überprüfen Sie alle Angaben, bevor Sie den Bericht absenden." />
      </Typography>

      <Paper elevation={1} sx={{ p: 3 }}>
        <Stack spacing={2}>
          <Box>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Kategorie
            </Typography>
            <Chip 
              label={currentCategory?.name} 
              color="primary" 
              variant="outlined"
            />
          </Box>

          {currentSubcategory && (
            <Box>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Unterkategorie
              </Typography>
              <Chip 
                label={currentSubcategory.name} 
                color="secondary" 
                variant="outlined"
              />
            </Box>
          )}

          <Box>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Beschreibung
            </Typography>
            <Typography variant="body1" sx={{ 
              p: 2, 
              bgcolor: 'grey.50', 
              borderRadius: 1,
              whiteSpace: 'pre-wrap'
            }}>
              {watchedDescription}
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Datum
            </Typography>
            <Typography variant="body2">
              {getCurrentDate()}
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
};
